// Roles de depósito. Espejo del enum `Deposits.depositType` del back
// (mirtomex-back/src/helpers/depositTypes.ts). Los cinco primeros forman el
// "perímetro de venta" que miden los informes de explotación (eficacia,
// reposición); el resto queda fuera de ese universo.

export const DEPOSIT_TYPE_OPTIONS = [
  { label: 'Tienda', value: 'store' },
  { label: 'Outlet', value: 'outlet' },
  { label: 'Córner', value: 'corner' },
  { label: 'Pop-up', value: 'popup' },
  { label: 'Venta remota (web/teléfono)', value: 'online' },
  { label: 'Almacén / logística', value: 'warehouse' },
  { label: 'Devoluciones', value: 'returns' },
  { label: 'Merma', value: 'shrinkage' },
  { label: 'Consumo interno', value: 'internal' },
];

export const RETAIL_DEPOSIT_TYPES = ['store', 'outlet', 'corner', 'popup', 'online'];

// Etiquetas cortas para listados (el label del selector es demasiado largo
// para una celda).
const SHORT_LABELS = {
  store: 'Tienda',
  outlet: 'Outlet',
  corner: 'Córner',
  popup: 'Pop-up',
  online: 'Online',
  warehouse: 'Almacén',
  returns: 'Devoluciones',
  shrinkage: 'Merma',
  internal: 'Interno',
};

export const depositTypeLabel = (type) => SHORT_LABELS[type] || type || '—';

export const isRetailDepositType = (type) => RETAIL_DEPOSIT_TYPES.includes(type);

// Status del Badge Polaris por rol: verde para el perímetro de venta,
// neutro para logística, atención para los sumideros técnicos.
export const depositTypeBadgeStatus = (type) => {
  if (isRetailDepositType(type)) return 'success';
  if (type === 'warehouse') return undefined;
  return 'attention';
};

/**
 * Etiqueta compacta para el botón del selector de alcance de depósitos de
 * los informes. Ejemplos: "Depósitos" (default), "Todos los depósitos",
 * "Rol: Tienda", "2 roles + 1 grupo", "3 depósitos".
 */
export const buildDepositScopeLabel = ({ depositsValue, depositRolesValue, depositGroupsValue, groupOptions = [] }) => {
  if (depositsValue === 'ALL') return 'Todos los depósitos';
  const roles = depositRolesValue ? depositRolesValue.split(':').filter(Boolean) : [];
  const groups = depositGroupsValue ? depositGroupsValue.split(':').filter(Boolean) : [];
  const deposits = depositsValue ? depositsValue.split(':').filter(Boolean) : [];

  const parts = [];
  if (roles.length === 1) parts.push(`Rol: ${depositTypeLabel(roles[0])}`);
  else if (roles.length > 1) parts.push(`${roles.length} roles`);
  if (groups.length === 1)
    parts.push(groupOptions.find((g) => String(g.value) === groups[0])?.label ?? '1 grupo');
  else if (groups.length > 1) parts.push(`${groups.length} grupos`);
  if (deposits.length === 1) parts.push('1 depósito');
  else if (deposits.length > 1) parts.push(`${deposits.length} depósitos`);

  return parts.length ? parts.join(' + ') : 'Depósitos';
};
